import { InjectionToken, Provider, REQUEST_CONTEXT, inject } from '@angular/core';

import { WINDOW } from '../browser/window/window.token';

/* @internal */
export const CLIENT_CONFIG_TOKEN = new InjectionToken<{ [key: string]: any }>('CLIENT_CONFIG_TOKEN', {
    providedIn: 'root',
    factory: () => inject(WINDOW)['clientConfig'],
});

export function provideClientConfig(fallbackClientConfig?: { [key: string]: any }): Provider[] {
    return [
        {
            provide: CLIENT_CONFIG_TOKEN,
            useFactory: () => {
                const requestClientConfig =
                    inject<{ clientConfig: { [key: string]: any } } | null>(REQUEST_CONTEXT)?.clientConfig ?? fallbackClientConfig ?? {};
                return Object.assign(inject(WINDOW), { clientConfig: requestClientConfig }).clientConfig;
            },
        },
    ];
}
